(() => {
  let start;
  const initialized = new Promise((resolve, reject) => {
    start = () => {
      Promise.resolve(window.Vinoshipper.init(1570, {})).then(() => {
        document.documentElement.classList.remove('cc-vs-unavailable');
        resolve(window.Vinoshipper);
      }).catch(reject);
    };
  });
  initialized.catch(() => document.documentElement.classList.add('cc-vs-unavailable'));
  window.CCVinoshipper = {
    ready: () => new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Checkout unavailable')), 15000);
      initialized.then(vs => { clearTimeout(timer); resolve(vs); }, error => { clearTimeout(timer); reject(error); });
    })
  };
  document.addEventListener('vinoshipper:loaded', start, { once: true });
  if (window.Vinoshipper) start();
  else {
    const script = document.createElement('script');
    script.src = 'https://vinoshipper.com/injector/index.js';
    script.async = true;
    script.addEventListener('error', () => document.documentElement.classList.add('cc-vs-unavailable'));
    document.body.append(script);
  }
  const fallbackTimer = setTimeout(() => document.documentElement.classList.add('cc-vs-unavailable'), 15000);
  initialized.then(() => clearTimeout(fallbackTimer)).catch(() => clearTimeout(fallbackTimer));
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cc-vs-cart]');
    if (!trigger) return;
    event.preventDefault();
    trigger.setAttribute('aria-busy', 'true');
    try {
      const vs = await window.CCVinoshipper.ready();
      vs.cartOpen();
    } catch {
      window.location.assign(trigger.href);
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  });
  const syncCount = () => {
    const cart = document.querySelector('vs-cart-button[data-vs-cart-count]');
    const count = Number(cart?.getAttribute('data-vs-cart-count') || 0);
    document.querySelectorAll('[data-cc-vs-count]').forEach(badge => {
      const value = String(count);
      if (badge.textContent !== value) badge.textContent = value;
      badge.hidden = !count;
    });
  };
  initialized.then(() => {
    syncCount();
    const cart = document.querySelector('#vs-cart');
    if (cart) new MutationObserver(syncCount).observe(cart, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-vs-cart-count'] });
  }).catch(() => {});
  document.addEventListener('shopify:section:load', () => initialized.then(vs => vs.render()).catch(() => {}));
})();
